/**
 * Mamba 🐍
 * Creating access to affordable therapy.
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import axios, { AxiosRequestConfig, Method } from 'axios';

import { axios as axiosClient, MambaApiError } from '../axios.config';

import { HTTPValidationError } from '../models/HTTPValidationError';
import { PartitionedPatientBillingEventsRead } from '../models/PartitionedPatientBillingEventsRead';
import { PatientBillingEventRead } from '../models/PatientBillingEventRead';

/* tslint:disable:no-unused-variable member-ordering max-line-length */
/* eslint-disable no-useless-concat */

export class PatientBillingEventsApiResource {
  /**
     * Get Partitioned Patient Billing Events
     * 
     * @param userId 
     
     */
  public getPartitionedPatientBillingEvents(
    userId: number,
    axiosConfig?: AxiosRequestConfig
  ): Promise<PartitionedPatientBillingEventsRead> {
    const apiRoute = '/patient-billing-events/{user_id}/partitioned';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Get Patient Billing Events
     * 
     * @param userId 
     
     */
  public getPatientBillingEvents(
    userId: number,
    axiosConfig?: AxiosRequestConfig
  ): Promise<Array<PatientBillingEventRead>> {
    const apiRoute = '/patient-billing-events/{user_id}';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Get Patient Billing Events By Appointment Id
     * 
     * @param appointmentId 
     
     */
  public getPatientBillingEventsByAppointmentId(
    appointmentId: number,
    axiosConfig?: AxiosRequestConfig
  ): Promise<Array<PatientBillingEventRead>> {
    const apiRoute = '/patient-billing-events/appointment/{appointment_id}';
    const reqPath = apiRoute.replace(
      '{' + 'appointment_id}',
      String(appointmentId)
    );
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }
}

export const PatientBillingEventsApi = new PatientBillingEventsApiResource();
